import { render, staticRenderFns } from "./qbList.vue?vue&type=template&id=1cfc6f81&"
import script from "./qbList.vue?vue&type=script&lang=js&"
export * from "./qbList.vue?vue&type=script&lang=js&"
import style0 from "./qbList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports